import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function MobileMenu({ onClose, navLinks }) {
    const menuVariants = {
        closed: {
            x: '100%',
            transition: { type: 'spring', stiffness: 400, damping: 40 }
        },
        open: {
            x: 0,
            transition: { type: 'spring', stiffness: 400, damping: 40, staggerChildren: 0.1, delayChildren: 0.2 }
        }
    };

    const itemVariants = {
        closed: { x: 50, opacity: 0 },
        open: { x: 0, opacity: 1 }
    };

    return (
        <motion.div
            initial="closed"
            animate="open"
            exit="closed"
            variants={menuVariants}
            className="fixed inset-0 z-40 bg-white/95 backdrop-blur-xl flex flex-col justify-center items-center"
        >
            <nav className="flex flex-col items-center gap-8">
                {navLinks.map((link) => (
                    <motion.div key={link.path} variants={itemVariants}>
                        <Link
                            to={link.path}
                            onClick={onClose}
                            className="text-3xl font-serif font-medium text-primary-900 hover:text-accent-500 transition-colors"
                        >
                            {link.name}
                        </Link>
                    </motion.div>
                ))}
                <motion.div variants={itemVariants} className="mt-8">
                    <Link
                        to="/agenda"
                        onClick={onClose}
                        className="px-8 py-3 bg-primary-900 text-white text-xl rounded-full font-medium hover:bg-primary-800 transition-colors shadow-xl"
                    >
                        Voir le Programme
                    </Link>
                </motion.div>
            </nav>
        </motion.div>
    );
}
